import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'
// TODO: Consider creating a reusable ExternalLink component
// import { ExternalLink } from '../../../../components'

interface Breadcrumb {
  label: string
  path: string
}

export const CommunityEducationalMaterialsPage: React.FC = () => {
  const pageTitle = 'Community Educational Materials'
  const breadcrumbs: Breadcrumb[] = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Community', path: '/toolkit/community' },
    {
      label: 'Limited SCD Providers',
      path: '/toolkit/community/limited-scd-providers'
    },
    {
      label: pageTitle,
      path: '/toolkit/community/community-educational-materials'
    }
  ]

  return (
    <ToolkitPageLayout title={pageTitle} breadcrumbs={breadcrumbs}>
      <div className="prose max-w-none text-[#3C2416]">
        <p className="text-lg mb-8">
          This page is dedicated to providing a collection of educational
          materials designed for community outreach and patient education
          regarding Sickle Cell Disease (SCD).
        </p>
        <ol className="list-decimal pl-5 mb-12 space-y-8">
          <li className="text-lg mb-6">
            <p className="mb-3">
              Watch video on pathophysiology of sickle cell disease below:
            </p>
            <div className="aspect-w-16 aspect-h-12 h-[50vh] w-[50vw] mx-auto mb-4 rounded-lg overflow-hidden shadow-lg">
              <iframe
                src="https://www.youtube.com/embed/FuelQDBOxXI"
                title="CRISIS: Experiences of People with Sickle Cell Disease Seeking Health Care for Pain"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full rounded-lg shadow-md"
              ></iframe>
            </div>
          </li>

          <li className="text-lg mb-6">
            <p className="mb-3">Review documents:</p>
            <div className="grid md:grid-cols-1 gap-6 mb-4">
              {/* Document Card with PDF embed */}
              <div className="bg-[#EDE6DE] p-6 rounded-lg shadow-lg">
                <h3 className="text-xl font-semibold text-[#142841] mb-3 text-center">
                  Community Health Workers and SCD
                </h3>
                <p className="text-sm text-gray-700 mb-5 text-center">
                  An article discussing the role and impact of Community Health
                  Workers in Sickle Cell Disease care.
                </p>
                <object
                  data="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4918511/pdf/nihms-787307.pdf"
                  type="application/pdf"
                  aria-label="Community Health Workers and SCD PDF Document"
                  className="w-full h-[700px] rounded-md border border-gray-300 mb-4"
                >
                  <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-md">
                    <p className="font-semibold">PDF Preview Not Available</p>
                    <p className="text-sm">
                      Your browser does not support embedding PDFs directly. You
                      can download the document to view it.
                    </p>
                  </div>
                </object>
                <div className="text-center mt-4">
                  <a
                    href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4918511/pdf/nihms-787307.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-base font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
                  >
                    Read Document
                  </a>
                </div>
              </div>
            </div>
          </li>

          <li className="text-lg mb-6">
            <p className="mb-3">
              Review video below about Sickle Cell Disease Coalition:
            </p>
            <div className="aspect-w-16 aspect-h-12 h-[50vh] w-[50vw] mx-auto mb-4 rounded-lg overflow-hidden shadow-lg">
              <iframe
                src="https://www.youtube.com/embed/oQP-Uq0BEqI"
                title="Sickle Cell Disease Coalition"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full rounded-lg shadow-md"
              ></iframe>
            </div>
          </li>
        </ol>

        {/* All Done Button - links back to Community Section Page */}
        <div className="mt-16 mb-12 text-center">
          <Link
            to="/toolkit/community" // Link to the main Community section page
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            Return to Community Resources
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
